'use client';

import { createContext, useContext } from 'react';
import type { PortalTheme } from './scope';

/**
 * The terminal window's theme, for whatever the window renders outside its own
 * element. A dialog it opens is portaled to the body, past the element the
 * theme is set on; this is how it carries the theme along. Null outside the
 * window, and on the default theme.
 *
 * Kept apart from index.ts on purpose: the shared Modal reads it, and must not
 * pull the themes or the skins' stylesheets into every page that shows a modal.
 */
export const TerminalWindowContext = createContext<PortalTheme | null>(null);
const NO_THEME: PortalTheme = {
  attrs: {},
  style: {}
};

/** The window's theme for a portaled root, or nothing outside the window. */
export const usePortalTheme = () => {
  return useContext(TerminalWindowContext) ?? NO_THEME;
};